import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { GuarantorListItem } from './components/GuarantorListItem';
import BorrowerDetail from './BorrowerDetail/BorrowerDetail';
import { SearchBox } from '../LoanList/LoanList';
import { useGetOwnerships } from '../../../services/ownership/querys';
import { useParams } from 'react-router-dom';
import { GuarrantorDetailViewContext } from '../Private';
import Spin from '../../../components/Atoms/Loader/Spin';
import { Pagination } from 'antd';

interface Props {
  children?: React.ReactNode;
}

const filterByNameOrLoanName = (term: string) => (items: any[]) =>
  items.filter(item => {
    const lowerTerm = term.toLowerCase();

    const matchesBorrowerName = item.name?.toLowerCase().includes(lowerTerm);
    const matchesLoanName = item.loans?.some(
      (loan: any) => loan.name?.toLowerCase().includes(lowerTerm)
    );

    return matchesBorrowerName || matchesLoanName;
  });

const Borrowers: React.FC<Props> = ({ }) => {

  const { borrowerId } = useParams();

  const { setHandlerVisible }: any = useContext(GuarrantorDetailViewContext);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searchTerm, setSearchTerm] = useState<string>('');

  const { data: ownerships, total, fetching: ownershipsLoading } = useGetOwnerships({
    variables: { search: searchTerm || undefined, page: currentPage, limit: pageSize }
  });

  const [filterFn, setFilterFn] = useState<(list: any[]) => any[]>(() => (list: any) => list);

  useEffect(() => {
    if(borrowerId) 
      setHandlerVisible(borrowerId);
  }, [borrowerId])

  const onSearchHandler = useCallback((term: string) => {
    setSearchTerm(term);
    setCurrentPage(1);
    // Rely on server-side search; do not apply additional client-side filtering
    setFilterFn(() => (list: any) => list);
  }, []);

  const filteredOwnerships = filterFn(ownerships);

  return (
    <div className="borrowers">
      <div className='top-container'>
        <div className='title'>
          Borrowers
        </div>
        <div>
        </div>
        <div>
          <SearchBox onSearch={onSearchHandler} />
        </div>
      </div>
      <div className='borrowers-container'>
        {ownershipsLoading ? (
          <Spin />
        ) : (
          filteredOwnerships?.map((ownership: any) => (
            <GuarantorListItem key={ownership._id} {...ownership} type='guarantor'/>
          ))
        )}
      </div>

      {!ownershipsLoading && (
        <div style={{ textAlign: 'center', marginTop: '16px'}}>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={total || 0}
            onChange={(page) => {
              setCurrentPage(page);
            }}
            onShowSizeChange={(_, newSize) => {
              setPageSize(newSize);
              setCurrentPage(1);
            }}
            showSizeChanger
            pageSizeOptions={['10', '20', '50', '100']}
            />
        </div>
      )}

      <BorrowerDetail/>
    </div>
  );
};

export default Borrowers;